function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcloudSuccess = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM10.71 16.2902C10.32 16.6802 9.68997 16.6802 9.29997 16.2902L7.19997 14.2002C6.80997 13.8102 6.80997 13.1802 7.19997 12.7902C7.58997 12.4002 8.21997 12.4002 8.60997 12.7902L9.99997 14.1802L14.48 9.70021C14.87 9.31021 15.5 9.31021 15.89 9.70021C16.28 10.0902 16.28 10.7202 15.89 11.1102L10.71 16.2902Z",
    fill: "#495057"
  }));
});